var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto px-2 pt-0 pb-2 px-md-0 width-slim"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }